"use client";

import { Button } from "@/components/ui/button";
import { useGmailAuth } from "@/hooks/use-gmail-auth";
import { Mail, Loader2, CheckCircle, X } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

export function GmailConnectButton() {
  const { connection, isConnecting, isLoading, error, connect, disconnect } =
    useGmailAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4 rounded-lg border bg-card">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (connection) {
    return (
      <div className="flex items-center justify-between p-4 rounded-lg border bg-card">
        <div className="flex items-center gap-3">
          <CheckCircle className="h-5 w-5 text-green-500" />
          <div>
            <p className="text-sm font-medium">Gmail Connected</p>
            <p className="text-xs text-muted-foreground">{connection.email}</p>
            {connection.lastSyncAt && (
              <p className="text-xs text-muted-foreground">
                Last synced{" "}
                {formatDistanceToNow(connection.lastSyncAt, { addSuffix: true })}
              </p>
            )}
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={disconnect}>
          <X className="h-4 w-4" />
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Button
        onClick={connect}
        disabled={isConnecting}
        className="w-full"
        variant="outline"
      >
        {isConnecting ? (
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        ) : (
          <Mail className="h-4 w-4 mr-2" />
        )}
        Connect Gmail Account
      </Button>
      {error && (
        <p className="text-sm text-destructive text-center">{error}</p>
      )}
    </div>
  );
}
